exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-80a9e2f0] {\n    line-height: 1;\n}\n.note-editor .note-editable[data-v-80a9e2f0] {\n    line-height: 1;\n}\n.note-editor .note-toolbar .note-dropdown-menu.note-check a i[data-v-80a9e2f0] {\n    visibility: visible !important;\n}\n", ""]);

// exports
